import React from "react";
import { NavLink } from "react-router-dom";
import "../style/home.css";
import homesection2image from "../assets/homesection2image.jpeg";
import castle from "../assets/castle.png";
import people from "../assets/people.png";
import car from "../assets/car.png";
import love from "../assets/love.png";
import bag from "../assets/bag.png";
import handshake from "../assets/handshake.png";
import castlelite from "../assets/castlelite.png";
import support from "../assets/support.png";
import ContentBlock from "./ContentBlock";
import section1video from "../assets/section1video.mp4";

const Home = () => {
  return (
    <div className="home-container">
      {/* Section 1 */}

      <section className="section1" id="homesection1 video-container ">
        <video
          autoPlay
          loop
          muted
          playsInline
          width="100%"
          height="400"
          className="background-video"
        >
          <source src={section1video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay">
          {/* <h1>Nurturing Life, Embracing Care</h1> */}
          <h4>
            Supporting individuals with learning disabilities, mental health
            challenges, and physical disabilities with dignity, respect, and
            professional care.
          </h4>
          <ContentBlock>
            <div className="section1-link">
              <NavLink to="/services" className="section1-link-a">
                <img src={castlelite} alt="castle" loading="lazy" /> Our
                Services
              </NavLink>
              <NavLink to="/contact-us" className="section1-link-a">
                <img src={support} alt="support" loading="lazy" /> Contact Us
              </NavLink>
            </div>
          </ContentBlock>
        </div>
      </section>
      <section className="section2">
        <h2>
          Welcome to Serenity Residential
          <br /> Care
        </h2>
        <ContentBlock>
          <div className="home-section2-div1">
            <div className="section2div1">
              <p className="section2-text">
                At Serenity Residential Care, we believe every <br /> individual
                deserves to live with dignity,
                <br /> respect, and independence. Our experienced <br /> team
                provides person-centered care that <br />
                supports individuals with learning disabilities,
                <br /> mental health challenges, and physical <br />
                disabilities. We work closely with families,
                <br />
                social workers,
                <br />
                and healthcare professionals to create <br /> tailored care
                plans that promote well-being <br /> and quality of life.
              </p>
              <div className="section2-link">
                <NavLink to="/about-us">Learn More About Us</NavLink>
              </div>
            </div>
            <div className="section2div2">
              <img src={homesection2image} alt="section2image" loading="lazy" />
            </div>
          </div>
        </ContentBlock>
      </section>
      <section className="section3">
        <div className="section3div1">
          <h1>Why Choose Serenity Care?</h1>
        </div>
        <ContentBlock>
          <div className="section3div2">
            <div className="section3div2-items">
              <img src={love} alt="love" loading="lazy" />
              <h3>Compassionate Care</h3>
              <h5>
                Person-centered care that
                <br /> respects dignity and <br /> promotes independence.
              </h5>
            </div>
            <div className="section3div2-items">
              <img src={bag} alt="bag" loading="lazy" />
              <h3>Safe & Secure</h3>
              <h5>
                Safe, secure environment <br /> with 24/7 professional <br />{" "}
                support and monitoring.
              </h5>
            </div>
            <div className="section3div2-items">
              <img src={people} alt="people" loading="lazy" />
              <h3>Experienced Team</h3>
              <h5>
                Qualified, experienced staff <br /> dedicated to providing{" "}
                <br />s exceptional care.
              </h5>
            </div>
            <div className="section3div2-items">
              <img src={handshake} alt="handshake" loading="lazy" />
              <h3>24/7 Support</h3>
              <h5>
                Round-the-clock care and <br /> support when you need it <br />{" "}
                most.
              </h5>
            </div>
          </div>
        </ContentBlock>
        <div className="section2-link">
          <NavLink to="/about-us">Find Out More</NavLink>
        </div>
      </section>

      <section className="section4">
        <div className="section4div1">
          <h1>Our Care Services</h1>
          <h5>
            Comprehensive care services designed to support individuals and
            families with professional, compassionate assistance.
          </h5>
        </div>
        <ContentBlock>
          <div className="section4div2">
            <div className="section4div2-items">
              <img src={castle} alt="castle" loading="lazy" />
              <h3>24/7 Residential Care</h3>
              <h5>
                Comprehensive residential care providing support with daily
                living, medication management, and personal care.
              </h5>
            </div>
            <div className="section4div2-items">
              <img src={people} alt="peaple" loading="lazy" />
              <h3>Respite Care</h3>
              <h5>
                Short-term care giving families and carers a well-deserved break
                while ensuring continuity of care.
              </h5>
            </div>
            <div className="section4div2-items">
              <img src={car} alt="car" loading="lazy" />
              <h3>Emergency Placement</h3>
              <h5>
                Immediate placement services available for urgent care needs
                with professional assessment.
              </h5>
            </div>
          </div>
        </ContentBlock>
        <div className="section2-link">
          <NavLink to="/about-us">Learn More About Us</NavLink>
        </div>
      </section>
      <section className="home-section5">
        <div className="home-section5-div1">
          <h1>Ready to Learn More?</h1>
          <h3>
            Contact our team today to discuss how we can support you or your
            loved one. We're here to help and answer any questions you may have.
          </h3>
          <p className="get-in-touch">
            <a href="tel:+[234][81313843]" className="footer-link">
              <span> Get in touch</span> Tel: 0121 769 3243
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Home;
